import {
  Basket,
  BasketItem,
  BasketItemApplianceDetails,
  BasketItemData,
  BasketItemQuoteDetails,
  CreateQuoteResponse,
} from '@common/util-models';

export enum ItemType {
  QuoteSky = 'QUOTESKYP',
  QuoteSkyMobile = 'QUOTESKYM',
}

export enum SkyBoxCategory {
  SkyBox = 'Sky Box',
}

export enum MobileDevice {
  Code = 'CP',
}

export enum MobileDeviceBrand {
  Sky = 'SKY',
}

export enum LaptopDevice {
  Code = 'LT',
}

export type SkyBoxEnumType = 'QK' | 'VIRTUAL';
export const SkyBoxEnum = {
  SkyQ: 'QK' as SkyBoxEnumType,
  Virtual: 'VIRTUAL' as SkyBoxEnumType,
};

export interface SkyCreateQuoteRequest {
  basketId?: string;
  itemType: ItemType.QuoteSkyMobile;
  applianceCode: string;
}

export interface SkyCreateQuoteResponse
  extends Omit<CreateQuoteResponse, 'basket'> {
  basket: SkyBasket;
}

export interface SkyBasket extends Omit<Basket, 'items'> {
  items: SkyBasketItem[];
}

export interface SkyBasketItem extends Omit<BasketItem, 'data'> {
  data: SkyBasketItemData;
}

export interface SkyBasketItemData
  extends Omit<BasketItemData, 'applianceDetails' | 'quotes'> {
  applianceDetails: SkyBasketItemApplianceDetails;
  quotes: Array<SkyBasketItemQuoteDetails>;
}

export interface SkyMobilePriceConfig {
  excessAmount: number;
  ltPrice: number;
  price: number;
  purchasePrice: number;
}

export interface SkyBasketItemApplianceDetails
  extends BasketItemApplianceDetails {
  ltPrice: number;
  ltMaxItems: number;
  bundleAppliances: BundleApplianceDetailsBasket[];
  skyMobilePriceConfig: SkyMobilePriceConfig[];
}

export interface BundleApplianceDetails {
  applianceCode: string;
  applianceId?: string;
  brandCode: string;
  imei?: string;
  modelNumber?: string;
  itemType?: string;
  phoneModel?: string;
  purchasePrice: number;
  purchaseDay?: number;
  purchaseMonth: number;
  purchaseYear: number;
  ltPrice?: number;
  serialNumber?: string;
  warranty: number;
  skyMobilePriceConfig?: SkyMobilePriceConfig[];
}

export interface BundleApplianceDetailsBasket extends BundleApplianceDetails {
  applianceId: string;
}

export interface SkyBasketItemQuoteDetails extends BasketItemQuoteDetails {
  numberOfItems: number;
  ltMaxItems?: number;
}

export interface AddBundleApplianceAPIRequestData {
  basketId: string;
  itemId: string;
  itemType: ItemType;
  appliances: BundleApplianceDetails[];
}

export interface RemoveBundleAppliancesAPIRequestData {
  basketId: string;
  itemId: string;
  itemType: ItemType.QuoteSky;
  appliances: RemoveBundleAppliancesAPIApplianceDetails[];
}

export interface RemoveBundleAppliancesAPIApplianceDetails {
  applianceId: string;
}

export interface UI_BasketItem {
  id: string;
  title?: string;
  image?: string;
  isIncluded?: boolean;
  price: number;
  covered?: boolean;
  coverPrice?: number;
  category?: string;
  type?: string;
  brand?: string;
}

export interface OrderSummary {
  skyBoxName: string | undefined;
  skyBoxPrice: number | undefined;
  includedDevices: UI_BasketItem[] | undefined;
  additionalDevices: UI_BasketItem[] | undefined;
  totalAmount: number | undefined;
  numFreePayments: number | undefined;
}

export interface MobileSearchPayload {
  countryCode: string;
  query: string;
  itemCode: string;
  manufBrandCode: string;
  pageNumber: number;
  pageSize: number;
}

export interface MobileSearchResponse {
  items: MobileDeviceData[];
}

export interface MobileDeviceData {
  itemModel: string;
  itemCode: string;
}
